import { themeColors } from '@/theme/colors';
import { Icon } from '@lego/connect-components-react';
import { Flex } from '@lego/klik-ui';

const DraggingFileView = () => (
  <Flex
    flexDirection="column"
    gap="12px"
    alignItems="center"
    justifyContent="center"
    flex="1"
    width="100%"
    borderRadius="12px"
    style={{
      border: `2px dashed ${themeColors.interactive.primary.enabled}`,
    }}
  >
    <Icon
      aria-label="upload"
      name="file"
      size="x-large"
      color="ds-color-interactive-primary-enabled"
    />
    <span className="body-md-regular">Drop your file here</span>
  </Flex>
);

export default DraggingFileView;
